import React, { useEffect, useRef } from 'react';
import { Circle, Popup } from 'react-leaflet';
import { idleBubbleRadius } from '../lib/idle-bubble-radius';

export const IdleBubbleCircle = ({ bubble, testId }) => {
  const circle = useRef(null);
  const radius = idleBubbleRadius(bubble);
  useEffect(() => {
    const element = circle.current?.getElement();
    if (element) {
      element.setAttribute('data-testid', testId);
      element.setAttribute('data-radius-meters', String(radius.meters));
      element.setAttribute('data-radius-source', radius.hasSavedRadius ? 'saved' : 'default');
      element.setAttribute('aria-label', `Idle area, ${radius.miles} mile radius`);
    }
  }, [testId, radius.meters, radius.miles, radius.hasSavedRadius]);
  return <Circle ref={circle} center={[bubble.lat, bubble.lng]} radius={radius.meters}
    pathOptions={{ color: '#7c3aed', fillColor: '#7c3aed', fillOpacity: 0.35, weight: 2 }}>
    <Popup>
      <strong>{bubble.name ? `Idle bubble · ${bubble.name}` : 'Idle bubble'}</strong><br />
      <span data-testid={`${testId}-duration`}>{bubble.duration_hours
        ? `Parked for ${(bubble.duration_hours * 60).toFixed(0)} min` : 'Idle cluster'}</span><br />
      <span data-testid={`${testId}-radius`}>Radius: {radius.miles.toLocaleString('en-US', { maximumFractionDigits: 3 })} mi{radius.hasSavedRadius ? '' : ' (default)'}</span>
    </Popup>
  </Circle>;
};